import React from "react";

//Jds
import { Container } from "@jds/core";

// Local
import Sidepanel from "./Sidepanel/Sidepanel";
import { Box } from "@mui/material";
import { Outlet } from "react-router-dom";

export default function EventDetailLayout(props) {
  return (
    <Container direction="row" fullWidth>
      <Sidepanel />
      <Box
        // p="32px 64px"
        p="32px 72px"
        // pr={"128px"}
        // style={{ flex: 1 }}
        // maxWidth={1158}
        mt={"72px"}
        sx={{
          flex: 1,
          // width: "680px",
          // maxWidth: "1158px",
        }}
      >
        <Outlet />
      </Box>
    </Container>
  );
}
